import React, { useEffect } from "react";
import { useUsers } from "../context/UsersContext";
import { useAuth } from "../context/AuthContext";
import { FaBook } from "react-icons/fa";

const CursosFooter = () => {
  const { user } = useAuth(); // Obtener datos del usuario logeado
  const {
    courses,
    salon,
    salonGrado,
    fetchCoursesForTeacher,
    fetchSalonForStudent,
    fetchSalonForDirector,
  } = useUsers();

  useEffect(() => {
    if (user.rol_id === 2) {
      fetchCoursesForTeacher(); // Se ejecuta una sola vez si no hay cursos
      if (!salonGrado) fetchSalonForDirector();
    } else if (user.rol_id === 3 && !salon) {
      fetchSalonForStudent();
    }
  }, [fetchSalonForDirector, fetchSalonForStudent, salonGrado, salon]);
  

  if (user.rol_id === 1) {
    return null; // Rector no ve cursos ni salones
  }

  return (
    <div>
      {/* Mostrar título solo si hay contenido */}
      {(user.rol_id === 2 && courses?.length > 0) || (user.rol_id === 3 && salon?.length > 0) ? (
        <h3 className="text-blue-900 text-lg font-bold mb-4">
          {user.rol_id === 2 ? "Cursos a Cargo" : "Detalles del Salón"}
        </h3>
      ) : null}

      <div className="mt-2 grid gap-4 px-6 w-full max-w-4xl">
        {/*  Cursos a Cargo */}
        {user.rol_id === 2 && courses?.length > 0 &&
          courses.map((course, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-3 items-center rounded-lg p-4 bg-gray-100"
            >
              <div className="flex items-center mb-2 md:mb-0">
                <div className="w-8 h-8 bg-green rounded-full flex items-center justify-center flex-shrink-0">
                  <FaBook className="text-white text-sm" />
                </div>
                <p className="ml-4 text-blue-900 font-bold">
                  {course.asignatura}
                </p>
              </div>
              <p className="font-bold text-blue-900 text-center">
                {course.salon_nombre}
              </p>
              <p className="text-gray-700 text-center">{course.grado}</p>
            </div>
          ))}

        {/* Director de Salón */}
        {user.rol_id === 2 && salonGrado && salonGrado.salon_nombre && (
          <>
            <h3 className="ml-[-25px] text-blue-900 text-lg font-bold mt-8 mb-4">
              Director de Salón
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 items-center rounded-lg p-4 bg-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <div className="w-8 h-8 bg-orange rounded-full flex items-center justify-center flex-shrink-0">
                  <FaBook className="text-white text-sm" />
                </div>
                <p className="ml-4 text-blue-900 font-bold">
                  {salonGrado.salon_nombre}
                </p>
              </div>
              <p className="font-bold text-blue-900 text-center">
                {salonGrado.salon_grado}
              </p>
            </div>
          </>
        )}

        {user.rol_id === 3 &&
          salon &&
          salon.map((salones, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-3 items-center rounded-lg p-4 bg-gray-100"
            >
              <div className="flex items-center mb-2 md:mb-0">
                <div className="w-8 h-8 bg-green rounded-full flex items-center justify-center flex-shrink-0">
                  <FaBook className="text-white text-sm" />
                </div>
                <p className="ml-4 text-blue-900 font-bold">
                  {salones.salon_nombre}
                </p>
              </div>
              <p className="text-gray-700 text-center">{salones.grado}</p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CursosFooter;
